import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export function MessageDialog({ open, onOpenChange, member }) {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post("/messages", { to_user_id: member.id, text: text.trim() });
      toast.success(`Message sent to ${member.name} 💌`);
      setText("");
      onOpenChange(false);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#150A1A] border border-pink-500/25 text-pink-50 sm:max-w-md" data-testid="message-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Message {member?.name}</DialogTitle>
          <DialogDescription className="text-slate-400">Your message goes straight to their inbox.</DialogDescription>
        </DialogHeader>
        <Textarea
          data-testid="message-text-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={4}
          placeholder="Write a private message…"
          className="bg-black/40 border-pink-500/25 text-pink-50 placeholder:text-slate-500 resize-none"
        />
        <button
          data-testid="message-send-btn"
          onClick={send}
          disabled={sending}
          className="w-full bg-gradient-to-r from-pink-600 to-rose-500 hover:from-pink-500 hover:to-rose-400 text-white font-medium py-3 rounded-full transition-all flex items-center justify-center gap-2 disabled:opacity-60"
        >
          <Send className="w-4 h-4" /> {sending ? "Sending…" : "Send message"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
